export const cleanFileName = (fileName) => {
  return fileName
    .replace(/\s+/g, '_')           // Espacios por guiones bajos
    .replace(/[áéíóúñ]/g, match => {  // Caracteres especiales
      const replacements = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'ñ': 'n' };
      return replacements[match] || match;
    })
    .replace(/[^\w\-_.]/g, '')      // Quitar caracteres raros
    .toLowerCase();
};

